import(/* webpackMode: "eager", webpackExports: ["CategoryGalleryClient"] */ "/Users/yoko/renehuemer.com/website/src/components/CategoryGalleryClient.tsx");
